import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { NumberSequence } from './number-sequence'
import { NumberSequenceService } from './number-sequence.service'

@Injectable({ providedIn: 'root' })
export class NumberSequenceResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private router = inject(Router)
  private sequenceService = inject(NumberSequenceService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<NumberSequence> {
    const id = route.paramMap.get('id')

    return this.sequenceService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('Failed to load number sequence', null, err)
        this.router.navigate(['app/settings'])
        return EMPTY
      })
    )
  }
}
